import * as React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function NurturingYoungMinds() {
  return <section data-section-id="69938" id="the-adventure-begins" className="bg-background text-foreground">
      {}
      <div className="bg-background w-full overflow-hidden relative">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            
            {}
            <div className="lg:col-span-7 flex flex-col items-start z-10">
              <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-bold text-foreground mb-6 leading-tight tracking-tight">
                Learn Spanish the Fun Way
              </h1>
              <p className="font-sans text-lg sm:text-xl text-muted-foreground mb-8 leading-relaxed max-w-2xl">
                Live online Spanish lessons for kids through games, songs, speaking, and playful learning adventures. Join our magical community where language feels like play.
              </p>
              
              <div className="flex flex-wrap gap-4">
                <Button asChild variant="default" size="lg" className="rounded-full px-8 py-6 text-base font-bold bg-primary text-primary-foreground hover:scale-105 transition-transform shadow-xl">
                  <Link to="/ContactPage">Book a Free Trial</Link>
                </Button>
                <Button asChild variant="secondary" size="lg" className="rounded-full px-8 py-6 text-base font-bold bg-secondary text-secondary-foreground hover:scale-105 transition-transform shadow-xl">
                  <Link to="/OurClassesPage">Explore Classes</Link>
                </Button>
              </div>
            </div>

            {}
            <div className="lg:col-span-5 relative mt-12 lg:mt-0 flex justify-center lg:justify-end">
              {}
              <svg className="absolute -top-16 -right-8 w-64 h-64 text-primary/20 z-0 animate-[spin_120s_linear_infinite]" viewBox="0 0 100 100" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M50 10 L55 30 L75 25 L65 40 L85 50 L65 60 L75 75 L55 70 L50 90 L45 70 L25 75 L35 60 L15 50 L35 40 L25 25 L45 30 Z" />
                <circle cx="50" cy="50" r="15" fill="currentColor" />
              </svg>

              {}
              <div className="relative z-10 w-full max-w-md">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1614297/img/laughing_child_cutout.png" alt="Laughing preschool child" className="w-full h-auto object-contain drop-shadow-2xl" />
              </div>

              {}
              <svg className="absolute -bottom-12 -left-12 w-48 h-32 text-secondary/30 z-20 opacity-90" viewBox="0 0 100 60" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M20 40 A15 15 0 0 1 20 10 A20 20 0 0 1 55 5 A25 25 0 0 1 90 25 A15 15 0 0 1 85 55 L20 55 Z" />
              </svg>
              
              <svg className="absolute top-1/4 -left-8 w-24 h-16 text-accent/20 z-20 opacity-80" viewBox="0 0 100 60" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M25 35 A10 10 0 0 1 25 15 A15 15 0 0 1 50 10 A18 18 0 0 1 75 25 A10 10 0 0 1 70 45 L25 45 Z" />
              </svg>
            </div>

          </div>
        </div>
      </div>
    </section>;
}